export { addGlobalEventProcessor, Scope } from './scope';
export { getCurrentHub, getHubFromCarrier, getMainCarrier, Hub, makeMain, setHubOnCarrier } from './hub';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/hub/esm/index.js
// module id = 29
// module chunks = 0